export default {
  widgetContainer: {
    width: '100%',
    height: '100%'
  }
};
